import React, { useState } from "react";
import styled from "./Project.module.css";
import { AiFillGithub } from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi";
import Modal from "react-modal";
import textutils from "../Images/textutils.png";
import todo from "../Images/todo.png";
import pinterest from "../Images/pinterest.png";
import chartered from "../Images/chartered.png";
import delma from "../Images/delma.png";
import chatbot from "../Images/chatbot.png";
import swiftaccess from "../Images/swiftaccess.png";
import prime from "../Images/prime.png";
import Airbnb from "../Images/airbnb.png";
import Portfolio from "../Images/portfolio.png";
import ssmErp from "../Images/ssm-erp-cover.svg";
import deltaShineErp from "../Images/deltashine-erp-cover.svg";

const Project = () => {
  const [modalState, setModalState] = useState({});

  const toggleModal = (key) => {
    setModalState((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const projects = [
    {
      title: "Super Shine ERP — Inventory Management",
      img: ssmErp,
      shortDesc:
        "Multi-branch ERP for a UAE metal coating company, tracking powder, paint and chemical stock in real time.",
      longDesc:
        "Built a real-time, multi-branch inventory management system for Super Shine Metal Coating L.L.C. Handles stock levels for powder, paint and chemicals across branches, inter-branch transfers, consumption tracking, and reporting for warehouse and production teams. Designed with role-based access for admins, store keepers, and branch managers.",
      tech: "Laravel || MySQL || JavaScript || Bootstrap || REST APIs",
      link: "https://erp.ssmcoating.com/dashboard",
      github: "",
      featured: true,
    },
    {
      title: "Delta Shine ERP — Project Cost & Finance",
      img: deltaShineErp,
      shortDesc:
        "ERP system for an aluminium & glass contractor covering project costing, petty cash and PDC cheque tracking.",
      longDesc:
        "Developed an ERP module suite for Delta Shine Aluminium & Glass to track project-level costs in real time, manage petty cash disbursements across sites, and record post-dated cheques (PDCs) with due-date alerts. Gives management a live view of project profitability and cash position.",
      tech: "Laravel || MySQL || JavaScript || Bootstrap || REST APIs",
      link: "https://erp.deltashineae.com/dashboard",
      github: "",
      featured: true,
    },
    {
      title: "SwiftAccess Website (KSA)",
      img: swiftaccess,
      shortDesc:
        "Responsive corporate website for a Saudi security solutions company.",
      longDesc:
        "Business website for a Saudi Arabian security solutions firm with product listings, services, dynamic pages, and admin backend. Fully responsive, SEO-optimized, and deployed with cross-device compatibility.",
      tech: "Laravel || MySQL || JavaScript || Bootstrap || HTML5 || CSS3",
      link: "https://swiftaccess-sa.com/",
      github: "",
    },
    {
      title: "Prime Overseas Consultancy Website",
      img: prime,
      shortDesc:
        "Professional consultancy website for an overseas education and immigration firm.",
      longDesc:
        "Built responsive UI with admin dashboard, blogs, SEO-optimized content, and service management for a consultancy firm.",
      tech: "Laravel || PHP || MySQL || Bootstrap || HTML || CSS || JavaScript",
      link: "http://primeoverseas.co/",
      github: "",
    },
    {
      title: "Home-Ezy E-commerce Platform",
      img: todo,
      shortDesc:
        "End-to-end e-commerce platform with a product dashboard and server-side rendering.",
      longDesc:
        "Developed a complete e-commerce solution with product APIs, user authentication, and payment gateway integration. Optimized for scalability and performance.",
      tech: "React.js || Next.js || Node.js || MongoDB",
      link: "https://home-ezy.net/home",
      github: "",
    },
    {
      title: "PinBoard — Pinterest Clone",
      img: pinterest,
      shortDesc:
        "A Pinterest-style visual content sharing app with boards and pins.",
      longDesc:
        "Includes user authentication, CRUD APIs, pin creation, board management, search functionality, and responsive design.",
      tech: "Express.js || Node.js || MongoDB || EJS || Tailwind CSS",
      link: "https://pinterest-clone-uyqo.onrender.com/",
      github: "",
    },
    {
      title: "Instagram & Airbnb Clones",
      img: Airbnb,
      shortDesc:
        "Full-stack clones inspired by Instagram and Airbnb platforms.",
      longDesc:
        "Features include authentication, CRUD operations, a user dashboard, and UI inspired by Instagram & Airbnb apps.",
      tech: "Node.js || Express.js || MongoDB || Tailwind CSS",
      link: "",
      github: "",
    },
    {
      title: "Personal Portfolio Website",
      img: Portfolio,
      shortDesc:
        "Personal portfolio showcasing skills, projects, and resume.",
      longDesc:
        "Built a responsive portfolio with a contact form API, project showcase, and deployment on Vercel.",
      tech: "React.js || Tailwind CSS || Vercel",
      link: "https://miftahportfolio.vercel.app/",
      github: "",
    },
    {
      title: "TextUtils",
      img: textutils,
      shortDesc:
        "Utility web app for text analysis such as word/character count and formatting.",
      longDesc:
        "Provides operations like case conversion, copy, clear, and reading-time estimation.",
      tech: "React || JavaScript || HTML || CSS || Bootstrap",
      link: "https://textutils-mif.vercel.app/",
      github: "",
    },
    {
      title: "Todo List",
      img: todo,
      shortDesc:
        "Simple task management app with priority and time management features.",
      longDesc:
        "Includes task creation, priority levels, due dates, and persistent task management.",
      tech: "React.js || Next.js || MongoDB || HTML || CSS",
      link: "https://todolist-mif.vercel.app/",
      github: "",
    },
    {
      title: "CharteredHelp Blog",
      img: chartered,
      shortDesc: "Dynamic blogging system with CMS integration and SEO.",
      longDesc:
        "Built features like blog creation, responsive UI, a commenting system, and an admin dashboard for content management.",
      tech: "Express.js || Node.js || MongoDB || EJS || HTML || CSS",
      link: "https://blog.charteredhelp.com/",
      github: "",
    },
    {
      title: "Delma Quotation & Invoice System",
      img: delma,
      shortDesc: "Laravel-based invoice management and quotation platform.",
      longDesc:
        "Features professional quotations, invoice tracking, an admin panel, and a Bootstrap-based UI.",
      tech: "Laravel || PHP || MySQL || JavaScript || Bootstrap || HTML || CSS",
      link: "http://delmabeach.com/login",
      github: "",
    },
    {
      title: "Telegram Bot",
      img: chatbot,
      shortDesc: "Node.js-based Telegram bot for automation and user interaction.",
      longDesc:
        "Implements webhooks, modular commands, real-time messaging, and API integration with scalability.",
      tech: "Node.js || Express.js || MongoDB || JavaScript",
      link: "",
      github: "",
    },
  ];

  return (
    <div id="project" className={styled.section}>
      <h1 className={styled.mid}>
        <span className={styled.accentText}>My</span> Projects
      </h1>
      <p className={styled.subtitle}>
        A selection of client, freelance, and personal projects — from
        production ERP systems to full-stack web apps.
      </p>

      <div className={styled.grid}>
        {projects.map((proj, index) => {
          const techList = proj.tech
            .split("||")
            .map((t) => t.trim())
            .filter(Boolean);

          return (
            <div key={index} className={styled.card}>
              <div className={styled.imgWrap}>
                <img
                  className={styled.img}
                  src={proj.img}
                  alt={proj.title}
                  loading="lazy"
                />
                {proj.featured && (
                  <span className={styled.badge}>Featured</span>
                )}
              </div>

              <div className={styled.cardBody}>
                <h3 className={styled.cardTitle}>{proj.title}</h3>
                <p className={styled.cardDesc}>{proj.shortDesc}</p>

                <div className={styled.tags}>
                  {techList.map((tech, i) => (
                    <span key={i} className={styled.tag}>
                      {tech}
                    </span>
                  ))}
                </div>

                <div className={styled.cardFooter}>
                  <button
                    onClick={() => toggleModal(index)}
                    className={styled.readMore}
                  >
                    Read more
                  </button>

                  <div className={styled.links}>
                    {proj.github && (
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={proj.github}
                        aria-label={`${proj.title} source code`}
                        className={styled.iconLink}
                      >
                        <AiFillGithub className={styled.icon} />
                      </a>
                    )}
                    {proj.link && (
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={proj.link}
                        aria-label={`${proj.title} live site`}
                        className={styled.iconLink}
                      >
                        <BiLinkExternal className={styled.icon} />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <Modal
                className={styled.background}
                overlayClassName={styled.overlay}
                isOpen={!!modalState[index]}
                onRequestClose={() => toggleModal(index)}
                ariaHideApp={false}
              >
                <h2 className={styled.accentText}>{proj.title}</h2>
                <p className={styled.modalDesc}>{proj.longDesc}</p>
                <h5 className={styled.modalTech}>Tech Stack: {proj.tech}</h5>
                <div className={styled.modalLinks}>
                  {proj.link && (
                    <a target="_blank" rel="noreferrer" href={proj.link}>
                      Visit project ↗
                    </a>
                  )}
                </div>
                <button
                  onClick={() => toggleModal(index)}
                  className={styled.btn}
                >
                  Close
                </button>
              </Modal>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Project;
